export const PIANO = [
    {
        id: 1,
        title: 'WebQuestion1',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'lowpass', frequency: 100, gain: 20, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },

    {
        id: 2,
        title: 'WebQuestion2',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'peaking', frequency: 100, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'highpass', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },
      // Define other applications similarly
] 

export const GUITAR = [
    {
        id: 1,
        title: 'WebQuestion1',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'lowpass', frequency: 100, gain: 20, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },

    {
        id: 2,
        title: 'WebQuestion2',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'peaking', frequency: 100, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'highpass', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },
    
    {
        id: 3,
        title: 'WebQuestion3',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'lowpass', frequency: 100, gain: 20, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },

    {
        id: 4,
        title: 'WebQuestion4',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'peaking', frequency: 100, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'highpass', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },

    {
        id: 5,
        title: 'WebQuestion5',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'lowpass', frequency: 100, gain: 20, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },

    {
        id: 6,
        title: 'WebQuestion6',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'peaking', frequency: 100, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'highpass', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },

    {
        id: 7,
        title: 'WebQuestion7',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'lowpass', frequency: 100, gain: 20, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },

    {
        id: 8,
        title: 'WebQuestion8',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'peaking', frequency: 100, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'highpass', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },

    {
        id: 9,
        title: 'WebQuestion9',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'lowpass', frequency: 100, gain: 20, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },

    {
        id: 10,
        title: 'WebQuestion10',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'peaking', frequency: 100, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'highpass', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },

    {
        id: 11,
        title: 'WebQuestion11',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'lowpass', frequency: 100, gain: 20, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },

    {
        id: 12,
        title: 'WebQuestion12',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'peaking', frequency: 100, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'highpass', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },

    {
        id: 13,
        title: 'WebQuestion13',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'lowpass', frequency: 100, gain: 20, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },

    {
        id: 14,
        title: 'WebQuestion14',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'peaking', frequency: 100, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'highpass', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },
]


export const VOCAL = [
    {
        id: 1,
        title: 'WebQuestion1',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'lowpass', frequency: 100, gain: 20, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },

    {
        id: 2,
        title: 'WebQuestion2',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'peaking', frequency: 100, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'highpass', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },
      // Define other applications similarly
]

export const SYNTH = [
    {
        id: 1,
        title: 'WebQuestion1',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'lowpass', frequency: 100, gain: 20, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },

    {
        id: 2,
        title: 'WebQuestion2',
        info: 'default question setting for change',
        audioSrc: '/audios/Color_Out_-_Host.mp3',
        filters: [
            { processorType: 'eq', type: 'peaking', frequency: 100, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 500, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 1000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'peaking', frequency: 5000, gain: 0, Q: 1, detune: 0, bypass: false },
            { processorType: 'eq', type: 'highpass', frequency: 10000, gain: 0, Q: 1, detune: 0, bypass: false },
        ], 
    },
      // Define other applications similarly
]